import RNA from "../assets/rna.jpg";
import Medicine from "../assets/medicine.jpg";
import  AU from "../assets/project1.jpg";
import Eflyer from "../assets/eflyer.jpg";
import VRHub from "../assets/vrhub.jpg";
import Task from '../assets/task.jpg';
import EcommercePanel from '../assets/ecommerceAdmin.jpg'

const projects = [
  {
    id: 1,
    name: "Task Management System",
    technologies: "React + Firebase + WebRTC",
    image: Task,
    github: "https://complete-task-management.vercel.app/",
  },
  {
    id: 2,
    name: "Ecommerce with website and Admin panel",
    technologies: "React + Redux + Tailwind CSS",
    image: EcommercePanel,
    github: "https://ecommerce-with-admin-panel.vercel.app/",
  },
  {
    id: 3,
    name: "VR Hub",
    technologies: "React.js + Tailwind CSS",
    image: VRHub,
    github: "https://vr-hub-site.netlify.app/",
  },
  {
    id: 4,
    name: "Eflyer",
    technologies: "MERN Stack",
    image: Eflyer,
    github: "https://github.com/rizwanabdullah11/Eflyer",
  },
  {
    id: 5,
    name: "AU Verse",
    technologies: "Flutter",
    image: AU,
    github: "https://github.com/rizwanabdullah11/au-verse",
  },
  {
    id: 6,
    name: "Medicine Recommendation System",
    technologies: "Machine Learning",
    image: Medicine,
    github: "https://github.com/rizwanabdullah11/medicine-recommendation",
  },
  {
    id: 7,
    name: "RNA Car Rentals",
    technologies: "C# (.Net)",
    image: RNA,
    github: "https://github.com/rizwanabdullah11",
  },
];

const Projects = () => {
  return (
    <div className="bg-black text-white py-20" id="project">
      <div className="mt-10 container mx-auto px-8 md:px-16 lg:px-24">
        <h2 className="text-4xl font-bold text-center mb-12 bg-gradient-to-r from-purple-800 to-purple-400 bg-clip-text text-transparent">
          My Projects
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project) => (
            <div key={project.id} className="bg-transparent border-2 border-purple-800 p-6 rounded-lg hover:shadow-lg 
            transform transition-transform duration-300 hover:scale-105">
              <img src={project.image} alt={project.name} className="rounded-lg mb-4 
              w-full h-48 object-cover" />
              <h3 className="text-2xl font-bold text-center mb-2">{project.name}</h3>
              <p className="text-gray-400 text-center mb-4">{project.technologies}</p>
              <div className="flex justify-center">
                <a
                  href={project.github}
                  className="inline-block bg-gradient-to-r from-purple-800 to-purple-400 text-white px-4 py-2 rounded-full pl-10 pr-10"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Link
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projects;
